/**
 * File validation constants shared between frontend validation and backend.
 * These should match the backend domain constants.
 */

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const FILE_EXTENSIONS = {
  PDF: '.pdf',
  JPEG: '.jpeg',
  JPG: '.jpg',
  PNG: '.png',
  GIF: '.gif',
  TXT: '.txt',
  CSV: '.csv',
  DOC: '.doc',
  DOCX: '.docx',
  XLS: '.xls',
  XLSX: '.xlsx',
} as const;

export const SUPPORTED_EXTENSIONS = Object.values(FILE_EXTENSIONS);

export const SUPPORTED_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/gif',
  'text/plain',
  'text/csv',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
] as const;

export const ACCEPT_EXTENSIONS = SUPPORTED_EXTENSIONS.join(',');

export const MIME_TYPE_TO_EXTENSION: Record<string, string> = {
  'application/pdf': FILE_EXTENSIONS.PDF,
  'image/jpeg': FILE_EXTENSIONS.JPEG,
  'image/png': FILE_EXTENSIONS.PNG,
  'image/gif': FILE_EXTENSIONS.GIF,
  'text/plain': FILE_EXTENSIONS.TXT,
  'text/csv': FILE_EXTENSIONS.CSV,
  'application/msword': FILE_EXTENSIONS.DOC,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    FILE_EXTENSIONS.DOCX,
  'application/vnd.ms-excel': FILE_EXTENSIONS.XLS,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    FILE_EXTENSIONS.XLSX,
};

export const EXTENSION_TO_MIME_TYPE: Record<string, string> = {
  [FILE_EXTENSIONS.PDF]: 'application/pdf',
  [FILE_EXTENSIONS.JPEG]: 'image/jpeg',
  [FILE_EXTENSIONS.JPG]: 'image/jpeg',
  [FILE_EXTENSIONS.PNG]: 'image/png',
  [FILE_EXTENSIONS.GIF]: 'image/gif',
  [FILE_EXTENSIONS.TXT]: 'text/plain',
  [FILE_EXTENSIONS.CSV]: 'text/csv',
  [FILE_EXTENSIONS.DOC]: 'application/msword',
  [FILE_EXTENSIONS.DOCX]:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  [FILE_EXTENSIONS.XLS]: 'application/vnd.ms-excel',
  [FILE_EXTENSIONS.XLSX]:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
